import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { AuthProvider } from './lib/auth/AuthContext';
import Login from './features/auth/components/Login';
import { ProtectedRoute } from './components/ProtectedRoute';
import Layout from './features/layout/components/Layout';
import ProposalsPage from './features/dashboard/components/Dashboard';
import DashboardPage from './features/dashboard/components/DashboardPage';
import ConfigurationPage from './features/configuration/pages/ConfigurationPage';
import FaqPage from './features/faq/components/FaqPage';
import SpreadProposalPage from './features/proposals/pages/SpreadProposalPage';
import ModuleInputsPrototype from './features/proposals/prototype/ModuleInputsPrototype'; // PROTOTYPE — remove when done
import SpreadSplitPrototype from './features/proposals/prototype/SpreadSplitPrototype'; // PROTOTYPE — remove when done
import awsconfig from './aws-exports';

// Fonts (Montserrat + Funnel Sans) are loaded via the Google Fonts
// link in public/index.html, per the CRC Evans design system.

// Configure Amplify
Amplify.configure(awsconfig);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/proposals" replace />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/proposals" element={<ProposalsPage />} />
                    <Route path="/proposals/new" element={<SpreadProposalPage />} />
                    <Route path="/proposals/:proposalId" element={<SpreadProposalPage />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/configuration" element={<ConfigurationPage />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/prototype/module-inputs" element={<ModuleInputsPrototype />} />
                    <Route path="/prototype/spread-split" element={<SpreadSplitPrototype />} />
                    <Route path="*" element={<Navigate to="/proposals" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
